<div class="row">
  <div class="col-md-10">
    <app-clients></app-clients>
  </div>
  <div class="col-md-2">
    <app-sidebar></app-sidebar>

  </div>

</div>